import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updatePassword, updateProfile } from "../../redux/actions/authAction";
import { toast } from "react-toastify";
import Blinking from "../../Loaders/Blinking";

export default function ProfileTab(props) {
  const { isUpdatePasswordStarted, profileData, isUpdateProfileStarted } = useSelector( (state) => state.authData );
  const {name, phone} = profileData || {}
  const dispatch = useDispatch();

  let formForUpdatePassword = useRef();
  const handleSubmitForUpdatePassword = (e) => {
    e.preventDefault();
    const { password, new_password, confirm_password } = formForUpdatePassword.current;
    if(new_password.value !== confirm_password.value) {
      toast.error("New password and Confirm password are not same.")
      return
    } else {
      let formdata = {
        password: password.value,
        new_password: new_password.value,
      };
      dispatch(updatePassword(formdata));
      formForUpdatePassword.current.reset();
    }
    
  };

  let formForUpdateProfile = useRef();
  const handleSubmitForUpdateProfile = (e) => {
    e.preventDefault();
    const { name, phone } = formForUpdateProfile.current;
    if(name.value === "") {
      toast.error("Name can not be empty")
      return
    }
    if(!(/^[a-zA-Z\s]*$/.test(name.value))) {
      toast.error("Only text allowed")
      name.classList.add('error')
      return
    } else {
      name.classList.remove('error')
    }
     
    if(phone.value.length > 0) {
      if (phone.value.length < 10) {
        toast.error("Phone number can not be less than 10 digits")
        phone.classList.add('error')
        return
      } else if (phone.value.length > 15) {
        toast.error("Phone number can not be more than 15 digits")
        phone.classList.add('error')
        return
      } else {
        phone.classList.remove('error')
      }
    } else {
      phone.classList.remove('error')
    }
   
    let formdata = {
      name: name.value,
      phone: phone.value,
    };
    dispatch(updateProfile(formdata));    
  };
  return (
    <div className="profileDetailsPanelBox">
      <div className="row">
        <div className="col-4 pr-0">
          <div className="clearfix profileArea">
            <form action="" className="form" ref={formForUpdateProfile} 
            onSubmit={handleSubmitForUpdateProfile}>
              {/* <div className="form-group">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  className="form-control readonly"
                  value="manmeetk"
                  readOnly
                />
              </div> */}
              <div className="form-group">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={name}
                  name="name"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Phone</label>
                <input
                      type="number"
                      className="form-control number-input"
                      defaultValue={phone}
                      name="phone"
                    />
                {/* <div className="row">
                  <div className="col-3 pr-0">
                    <select
                      name=""
                      className="form-control select_arrow_gray"
                    >
                      <option value="">+1</option>
                      <option value="">+2</option>
                      <option value="">+3</option>
                      <option value="">+4</option>
                    </select>
                  </div>
                  <div className="col-9">
                    <input
                      type="text"
                      className="form-control number-input"
                      value="72777 000 123456"
                    />
                  </div>
                </div> */}
              </div>
              <div className="form-group mt-5">
                <button
                  type="submit"
                  className="submit-btn submit-primary mt-0"
                >
                  Save Changes {isUpdateProfileStarted && <Blinking fontSize={20} />}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="col-1"></div>
        <div className="col-4 pl-0">
          <div className="clearfix profileArea">
            <form action="" className="form" ref={formForUpdatePassword} 
            onSubmit={handleSubmitForUpdatePassword}>
              <div className="form-group">
                <label className="form-label">Old Password</label>
                <input type="password" className="form-control" name="password" required minLength="6" />
              </div>
              <div className="form-group">
                <label className="form-label">New Password</label>
                <input type="password" className="form-control" name="new_password" required minLength="6" />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm New Password</label>
                <input type="password" className="form-control" name="confirm_password" required minLength="6" />
              </div>
              <div className="form-group mt-5">
                <button type="submit" className="submit-btn mt-0">
                  Save Password
                  {isUpdatePasswordStarted && <Blinking fontSize={20} />}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
